<template>
    <v-container class="inner-main pt-2 mb-10">
        <v-btn size="default" color="default" flat fab icon="mdi-arrow-left" class="back-button"
            @click="$router.push(`/fairling/${route.params.id}/`)"></v-btn>
        <v-row justify="start" class="mt-3">
            <v-col cols="12">
                <div class="d-flex align-center">
                    <h1>{{ currentProduct != null ? currentProduct?.title : '' }}</h1>
                    <span class="d-flex align-center">
                        <v-icon class="me-1" icon="mdi-heart-outline"></v-icon>
                        {{ $t('entity.action.save') }}
                    </span>
                </div>
                <CustomSlider :autoplay="productImages?.length > 1 ? 4000 : null" :wrapAround="true" :imageType="'normal'"
                    :count="1" :slides="productImages" :imageDescription="false" :clickable="false"
                    :galleryName="'STREAM_MERCHANT'">
                </CustomSlider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <p class="paragraphed-text" v-html="currentProduct?.description"></p>
                <div v-if="currentProduct && currentProduct?.labels && currentProduct?.labels.length > 0" class="my-2">
                    <v-chip variant="flat" :color="label.color != '' ? label.color : '#e88be9'"
                        class="white--text colored-chip mr-2 my-1" v-for="label in currentProduct?.labels"
                        :key="label.id" @click="() => triggerOpenDiscoverPopup(label)">{{
                            label.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
                </div>
            </v-col>
            <v-col cols="12" lg="4" class="price-details">
                <v-row class="mt-3" justify="between" v-if="currentProduct?.purchasePrice != null">
                    <v-col class="text-left">{{ $t('fairling.profile.productHighlight.full.purchasePrice') }}</v-col>
                    <v-col class="text-right">{{ $convertCentsToEuros(currentProduct?.purchasePrice) }}</v-col>
                </v-row>
                <v-row class="mt-3" justify="between" v-if="currentProduct?.minimumOrder != null">
                    <v-col class="text-left">{{ $t('fairling.profile.productHighlight.full.minimumOrder') }}</v-col>
                    <v-col class="text-right">{{ $convertCentsToEuros(currentProduct?.minimumOrder) }}</v-col>
                </v-row>
                <v-row class="mt-0 mb-1" justify="between" v-if="currentProduct?.retailPrice != null">
                    <v-col class="text-left">UVP (brutto)</v-col>
                    <v-col class="text-right">{{ $convertCentsToEuros(currentProduct?.retailPrice) }}</v-col>
                </v-row>
                <v-row class="mt-0 mb-1" justify="between"
                    v-if="currentProduct?.retailPriceFrom != null || currentProduct?.retailPriceTo != null">
                    <v-col cols="4" class="text-left">UVP (brutto)</v-col>
                    <v-col class="text-right">von {{ $convertCentsToEuros(currentProduct?.retailPriceFrom) }} bis {{
                        $convertCentsToEuros(currentProduct?.retailPriceTo) }}</v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <v-btn variant="flat" size="large" color="primary" rounded="lg" class="white--text mb-2 w-100"
                    @click="() => triggerOpenContactDialog(currentCompany)">{{ $t('fairling.profile.contactRequest.getInTouch') }}</v-btn>
                <v-btn variant="outlined" size="large" rounded="lg" class="mb-2 w-100"
                    @click="$router.push(`/fairling/${route.params.id}`)">{{ $t('fairling.profile.storefinder.findeling') }}</v-btn>
            </v-col>
        </v-row>




        <CustomTopSheetDialog v-model="showSheet" :width="600"
            :title="`Video ${currentCompany != null ? currentCompany.name : ''}`">
            <div class="video-wrapper">
                <iframe :src="`${$vimeoUrl}${currentCompany.vimeoLink}`" frameborder="0"
                    allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </CustomTopSheetDialog>
    </v-container>
</template>

<script>
import { ref, inject, computed } from 'vue';
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
import CustomPostCard from '@/components/custom/CustomPostCard.vue';
import CustomSlider from '@/components/custom/CustomSlider.vue';
import CustomSliderImage from '@/components/custom/CustomSliderImage.vue';
import { useRoute } from 'vue-router'

export default {
    components: {
        CustomTopSheetDialog,
        CustomSlider,
        CustomSliderImage,
        CustomPostCard
    },
    setup() {
        // const showSheet = ref(false);

        const openContactDialog = inject('openContactDialog')

        const triggerOpenContactDialog = (merchant) => {
            openContactDialog(merchant);
        }
        const currentProduct = ref(null)

        const openDiscoverPopup = inject('openDiscoverPopup');

        const triggerOpenDiscoverPopup = (label) => {
            openDiscoverPopup(label);
        }

        const productImages = computed(() => {
            if (currentProduct.value == null) return
            return currentProduct.value.images.map(image => {
                return image.id;
            })
        })


        const route = useRoute()
        const config = {
            itemsToShow: 3
        }
        const selectedLanguage = localStorage.getItem('selectedLanguage');
        const openText = ref(false);
        return {
            // showSheet:false,
            config,
            openText,
            route,
            selectedLanguage,
            triggerOpenContactDialog,
            triggerOpenDiscoverPopup,
            currentProduct,
            productImages
        };
    },

    data() {
        return {
            currentCompany: {},
            // currentProduct: {},
            htmlContent: "<strong>Hello, World!</strong> This is <em>raw HTML</em>.",
            showSheet: false,
            items: [
                "Kundenmagnet",
                "Image Booster",
                "Must-Have",
                "Geheimtipp",
                "Margen-Held",
                "PR-Star",
                "Kundenliebling",
                "Durchstarter",
            ],
            images: [
                "https://picsum.photos/200/300", "https://picsum.photos/300/300", "https://picsum.photos/500/300"
            ]
        }
    },

    mounted() {
        this.fetchCompanyProfile();
    },

    methods: {
        fetchCompanyProfile() {
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            var _this = this;
            this.$axios.get("/merchant/t/" + this.route.params.id, {
                headers: {
                    'X-Auth-HARDTOKEN': hardToken,
                    'X-Auth-USER': username
                },

            })
                .then(this.companyFetched)
                .catch(error => {
                    
                    // You can handle specific error codes here, for example, a 401 Unauthorized
                    if (error.response && error.response.status === 401 || error.response.status === 403) {
                        // Handle token expiration or unauthorized error
                        console.log("Session expired or unauthorized. Please log in again.");
                        _this.$router.replace('/login');
                        // Optionally log the user out or redirect to login page
                    } else if (error.response && error.response.status === 500) {
                        _this.$router.push('/404')
                    }
                });

        },
        companyFetched(response) {
            this.currentCompany = response.data.data;
            this.currentProduct = this.currentCompany.productHighlights.find((highlight) => highlight.id == this.route.params.productId);
        }
    },
};
</script>

<style scoped>
.inner-main {
    margin-left: auto;
    margin-right: auto;
    max-width: 1170px;
}

.description-wrapper {
    position: relative;
}

/*h3 {
    font-family: Manrope, sans-serif;
    color: #202020;
    font-weight: 700;
    font-size: 17px;
    line-height: 1.3;
}*/

a {
    text-decoration: none;
}

.description-text {
    display: block;
    max-height: 200px;
    /* Adjust the height based on your design */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    transition: max-height 0.3s ease-in-out;
    font-size: 14px;
}

.description-text.truncated {
    max-height: 200px;
    /* Limit text height when truncated */
}

.description-text:not(.truncated) {
    max-height: none;
    /* Allow full text to show when toggled */
}

.text-link {
    text-decoration: none;
    color: #1e88e5;
    cursor: pointer;
    float: right;
}

.text-link:hover {
    text-decoration: underline;
}

.back-button {
    position: absolute;
    left: 250px;
}

.back-button .v-icon {
    width: 20px !important;
    height: 20px !important;
    min-width: none;
    min-height: none;
}
</style>

<style>
/*.dialog-list-item {
    min-height: 30px !important;
    background-color: transparent !important;
  }
  
  */
.price-details {
    font-weight: 500;
    font-size: 16px;
}

.colored-chip {
    color: white !important;
}

.video-wrapper {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 ratio */
    height: 0;
    overflow: hidden;
}

.video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}



.share-hint,
.descrption-text {
    font-size: 14px !important;
}

h1 {
    font-size: 36px !important;
    ;
}

h4 {
    font-size: 16px !important;
    font-weight: 700;
}

.f-16 {
    font-size: 16px !important;
}

.edit-btn {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
}

.logo-sheet {
    background-image: url('https://d2v01xjmjw73dt.cloudfront.net/api/image/collection/6cc5fce5-d423-4af3-8bf8-e5d25a234e80/AVATAR');
    background-size: cover;
}


.paragraphed-text {
    white-space: pre-wrap;
    word-break: break-word;
}
</style>